import api from "../api";

export const getNotifications = async (doctorId) => {
    try {
        const response = await api.get(`/notifications/${doctorId}`, {
            credentials: "include",
        });

        if (!(response.status === 200)) {
            throw new Error("Network response was not ok");
        }

        return await response.data;
    } catch (error) {
        throw error.message;
    }
}

export const markNotificationAsRead = async (doctorId, notificationId) => {
    try {
        const response = await api.patch(`/notifications/${doctorId}/${notificationId}/read`, {}, {
            credentials: "include",
        });

        if (!(response.status === 200)) {
            throw new Error("Network response was not ok");
        }

        return await response.data;
    } catch (error) {
        throw error.message;
    }
}